window.onload = function(){
    let ingredients = document.getElementsByClassName('complete-data');
    let ingredient_content;
    let cuantity_content;
    Array.from(ingredients).forEach(ingredient => {
        ingredient.style.display = 'none';
        cuantity_content = ingredient.innerText;
        ingredient = ingredient.parentNode;
        ingredient_content = ingredient.getElementsByTagName('a');
        ingredient_content[0].classList.add('ingredient--label');
        ingredient_content[0].innerText = cuantity_content + " " + ingredient_content[0].innerText
    });
}

function recipeTabSwitch(tab_id, tab_content, this_recipe ) {
    // first of all we get all tab content blocks (I think the best way to get them by class names)
    var recipe_container = document.getElementsByClassName("tabcontent-" + this_recipe );
    var item;
    for (item = 0; item < recipe_container.length; item++) {
        recipe_container[item].style.display = 'none'; // hide all tab content
    }
    document.getElementById(tab_content).style.display = 'block'; // display the content of the tab we need
    
    // now we get all tab menu items by class names (use the next code only if you need to highlight current tab)
    var recipe_item = document.getElementsByClassName("tabmenu-" + this_recipe );
    var item;
    for (item = 0; item < recipe_item.length; item++) {
        recipe_item[item].className = 'tabmenu-' + this_recipe; 
    }
    document.getElementById(tab_id).className = 'tabmenu-' + this_recipe + ' active';
}

function printPageArea(areaID){
     const recipe_content = document.getElementById(areaID);
      const recipe_name = recipe_content.querySelector('.recipe-card__header__title').innerHTML;
  
      const print = () => page.print();
      recipe_content.onclick = () => print();
  
  
      const page = window.open('', '', 'width=900,height=650');
      page.document.write(`
        <html>
            <head>
                <title>Print Preview - ${recipe_name}</title>
                <style>
                    body { 
                      overflow-x: hidden; 
                      font-family: 'Helvetica Neue', sans-serif;
                      line-height: 1.25;
                    }
                    img { 
                      width: 200px; 
                    }
                    a { 
                      display: none; 
                    }
                    @media print {
                      #controls { 
                        display: none; 
                      }
                    }
                    .recipe-manual {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .recipe-card {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center; 
                    }
                    .recipe-card__header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        padding: 20px;
                        font-weight: 600;
                    }
                    .recipe-card__header__title {
                        font-size: 20px;
                        line-height: 1.15;
                        letter-spacing: 2px;
                        text-transform: capitalize;
                        text-align: center;
                        margin-top: 20px;
                        margin-bottom: 20px;
                    }
                    .recipe-card__header__details {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-evenly;
                        width: 100%;
                        margin-bottom: 0 !important;
                        padding-bottom: 0 !important;
                    }
                    .recipe-card__header__details__item {
                        display: flex;
                        flex-direction: column;
                        text-align: center
                    }
                    .recipe-card__header__details__item .recipe-card__header__details__item__label {
                        font-size: 14px;
                        line-height: 1.15;
                        text-transform: capitalize;
                        margin: 0;
                        font-family: 'Helvetica Neue', sans-serif;
                    }
                    .recipe-card__header__details__item .recipe-card__header__details__item__data {
                        font-size: 14px;
                        line-height: 1.15;
                        text-transform: capitalize;
                        margin: 0;
                        font-family: 'Helvetica Neue', sans-serif;
                    }
                    .recipe-card__header__social-media {
                        display: none;
                    }
                    .recipe-card__instructions__divisor {
                        display: none;
                    }
                    .recipe-card__instructions {
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                        padding-top: 0 !important;
                        padding: 20px;
                        justify-content: space-between;
                    }
                    .recipe-card__instructions__mobile {
                        display: none;
                    }
                    .recipe-card__instructions__ingredients {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 48%;
                        height: 45px;
                        border-radius: 10px 10px 0px 0px;
                    }
                    .recipe-card__instructions__instructions {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 48%;
                        height: 45px;
                        border-radius: 10px 10px 0px 0px;
                    }
                    .recipe-card__instructions h3 {
                        font-size: 18px;
                        line-height: 30px;
                        margin: 0;
                        font-family: 'Helvetica Neue', sans-serif;
                        margin-bottom: 0 !important;
                        padding-bottom: 0 !important;
                    }
                    & .recipe-card__instructions__title {
                        font-size: 18px;
                        line-height: 1.15;
                        letter-spacing: 1.5px;
                        text-transform: uppercase;
                    }
                    .recipe-card__instructions--ingredients {
                        width: 37%;
                        display: block !important;
                    }
                    .recipe-card__instructions--instructions {
                        width: 63%;
                        display: block !important;
                    }
                    .recipe-card__instructions--ingredients h3 {
                        padding-left: 30px;
                    }
                    .recipe-card__instructions--instructions h3 {
                        padding-left: 50px;
                    }
                    .recipe-card__instructions--ingredients h4 {
                        font-size: 18px;
                        line-height: 25px;
                        text-transform: uppercase;
                        letter-spacing: 0;
                        margin-top: 0px;
                        margin-bottom: 20px;
                    }
                    .recipe-card__instructions .ingredient-header {
                      list-style-type: none;
                      padding: 0;
                      margin-left: -10px;
                      margin-bottom: 0;
                    }
                    .recipe-card__instructions .ingredient-header h4 {
                      margin-bottom: 0 !important;
                      font-size: 14px;
                      font-family: 'Helvetica Neue', sans-serif !important;
                      margin-top: 20px;
                    }
                    .recipe-card__instructions--ingredients .ingredient {
                      font-size: 12px;
                      line-height: 1.25;
                      padding-bottom: 0;
                      margin-bottom: 0;
                    }
                    .recipe-card__instructions--ingredients .ingredient * {
                      line-height: 1.25;
                      margin-bottom: 0 !important;
                      padding-bottom: 0 !important;
                    }
                    .recipe-card__instructions--ingredients .ingredient::before {
                      display: none;
                    }
                    .recipe-card__instructions--ingredients a {
                        text-decoration: none;
                        color: #000 !important;
                        opacity: 1;
                        display: block !important;
                    }
                    .get-ingredient--container {
                        display: flex;
                        justify-content: flex-start;
                    }
                    .get-ingredient,
                    .chicory-order-ingredients {
                        display: none;
                    }
                    .step--color {
                        padding: 0px 15px 20px 15px;
                    }
                    .recipe-card__instructions__image {
                        max-height: 340px;
                        width: 100%;
                        display: flex;
                        margin-bottom: 30px;
                        margin-left: 50px;
                    }
                    & img {
                        max-width: 100%;
                        padding-left: 11%;
                        max-height: 310px;
                    }
                    .step {
                        font-size: 12px;
                        line-height: 1.15;
                        padding-bottom: 0;
                    }
                    .step::marker {
                        font-size: 12px;
                    }
                    .recipe-card__notes {
                        display: flex;
                        flex-direction: column;
                        width: 90%;
                        padding-bottom: 70px;
                    }
                    .recipe-card__notes h3 {
                        font-size: 28px;
                        line-height: 30px;
                        margin: 10px 0 10px 0;
                    }
                    .recipe-card__notes p {
                        margin: 5px 0px 0px 0px;
                    }
                    .recipe-card__notes em {
                        font-size: 12px;
                        line-height: 35px;
                    }
                </style>
            </head>
            <body>
                ${recipe_content.outerHTML}
            </body>
        </html>
  `);
      page.document.close();
  page.onafterprint = () => {
    page.close();
  }
  }